import { render, staticRenderFns } from "./User-grade.vue?vue&type=template&id=1f029ac0&scoped=true&"
import script from "./User-grade.vue?vue&type=script&lang=js&"
export * from "./User-grade.vue?vue&type=script&lang=js&"
import style0 from "./User-grade.vue?vue&type=style&index=0&id=1f029ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f029ac0",
  null
  
)

export default component.exports